module.exports = __webpack_public_path__ + "img/alpha-test-group.080ed866.svg";